import { FC } from 'react';
// components
import AddSweetenerComponent from 'components/main/SweetenerComponent/Edit';

const AddSweetenerComponents: FC = () => <AddSweetenerComponent />;

export default AddSweetenerComponents;
